var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormatListNumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 20,
    viewBox: "0 0 22.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "format_list_numbered_FILL1_wght400_GRAD0_opsz48",
    d: "M6,28V26.938H8.625v-.812H7.313V25.063H8.625V24.25H6V23.188H9.688V28ZM7.313,12.875V9.063H6V8H8.375v4.875ZM6,20.406v-1l2.344-2.75H6V15.594H9.688v1l-2.375,2.75H9.688v1.063Zm6.531,6.063V24.594H28.5v1.875Zm0-7.594V17H28.5v1.875Zm0-7.594V9.406H28.5v1.875Z",
    transform: "translate(-6 -8)",
    fill: "#586973"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatListNumb);
export default __webpack_public_path__ + "static/media/format_list_numb.3a0b4428.svg";
export { ForwardRef as ReactComponent };